"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.grid = {
  breakpoints: {
    xs: 0,
    sm: 359,
    md: 599,
    lg: 1023,
    xl: 1279
  },
  columns: 12,
  gutter: 12,
  mobileGutter: 8,
  minWidth: 320,
  margin: 20
};
exports.FlexGrid = styled_components_1.default.div(_templateObject());